import React, { useEffect, useState } from "react";
import { Seo } from "@/components/Seo";
import { useParams } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { useAuth } from "@/context/AuthContext";
import { api } from "@/lib/api";
import { TIERS } from "@/lib/badges";
import { BackLink } from "@/components/BackLink";
import { VOLUNTEER } from "@/constants/testIds";
import { Printer, Award } from "lucide-react";

export default function Certificate() {
  const { tierId } = useParams();
  const { user } = useAuth();
  const [stats, setStats] = useState({ total_hours: 0 });
  const tier = TIERS.find(t => t.id === tierId) || TIERS[0];

  useEffect(() => { api.myStats().then(setStats).catch(() => {}); }, []);

  if (!user) return null;
  const today = new Date().toLocaleDateString("en-US", { year: "numeric", month: "long", day: "numeric" });

  return (
    <div className="max-w-4xl mx-auto px-6 py-10">
      <Seo title="Certificate" />
      <div className="no-print"><BackLink /></div>
      <div className="flex items-center justify-between no-print">
        <h1 className="font-display text-3xl text-forest tracking-tight">Your certificate</h1>
        <Button data-testid={VOLUNTEER.certPrintBtn} onClick={() => window.print()} className="rounded-full bg-forest hover:bg-forest-hover">
          <Printer className="w-4 h-4 mr-2" /> Print / Save as PDF
        </Button>
      </div>

      <div className="certificate-print mt-8 bg-white border-[6px] border-double border-forest rounded-2xl p-12 relative overflow-hidden">
        <div className="absolute inset-0 pointer-events-none opacity-5" style={{
          backgroundImage: "radial-gradient(circle at 20% 20%, #1A4331 1px, transparent 1px)",
          backgroundSize: "24px 24px",
        }} />
        <div className="text-center">
          <Award className="w-12 h-12 text-terracotta mx-auto" />
          <div className="text-xs uppercase tracking-[0.3em] text-forest/70 font-bold mt-4">Certificate of contribution</div>
          <div className="font-display text-4xl text-forest mt-5">Presented to</div>
          <div className="font-display text-5xl text-forest mt-2 tracking-tight">{user.name}</div>
          <div className="text-neutral-700 mt-7 max-w-xl mx-auto leading-relaxed">
            In recognition of <span className="font-semibold text-forest">{stats.total_hours} hours</span> of approved volunteering
            across the CivicHearth community — reaching the <span className="font-semibold" style={{ color: tier.color }}>{tier.label} tier</span>.
          </div>

          <div className="mt-12 grid grid-cols-2 gap-12 max-w-md mx-auto text-left">
            <div>
              <div className="border-b border-neutral-300 pb-1 font-display text-lg text-forest">CivicHearth</div>
              <div className="text-xs uppercase tracking-[0.18em] text-neutral-500 mt-1">Issuer</div>
            </div>
            <div>
              <div className="border-b border-neutral-300 pb-1 font-display text-lg text-forest">{today}</div>
              <div className="text-xs uppercase tracking-[0.18em] text-neutral-500 mt-1">Date</div>
            </div>
          </div>

          <div className="text-[10px] uppercase tracking-[0.3em] text-neutral-400 mt-12">civichearth.community · verifiable contribution</div>
        </div>
      </div>
    </div>
  );
}
